import { useMemo } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { StackSuggestions } from "constants/stack";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const StacksTableSpaceCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const spaceFilterAction = useCellFilterAction({
    filterName: StackSuggestions.Space,
    filterValue: stack.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellSpace
        href={`/spaces/${stack.spaceDetails.id}`}
        onPress={() => trackAnalytics("Space link clicked")}
      >
        {stack.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default StacksTableSpaceCell;
